import React from "react";

// Place inside a wrapper whose background is the CURRENT section colour.
// `fill` should be the NEXT section's background colour (hex).
export const WaveDivider = ({ fill = "#fafaf9", flip = false, className = "" }) => (
  <div aria-hidden="true" className={`pointer-events-none -mb-px block leading-none ${className}`}>
    <svg
      viewBox="0 0 1440 80"
      preserveAspectRatio="none"
      className={`w-full h-[36px] sm:h-[60px] ${flip ? "rotate-180" : ""}`}
    >
      <path
        fill={fill}
        d="M0,40 C240,86 480,4 720,30 C960,56 1200,86 1440,40 L1440,80 L0,80 Z"
      />
    </svg>
  </div>
);
